import { render, staticRenderFns } from "./ProfilePictureUpload.vue?vue&type=template&id=8a39a9ea&scoped=true"
import script from "./ProfilePictureUpload.vue?vue&type=script&lang=js"
export * from "./ProfilePictureUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a39a9ea",
  null
  
)

export default component.exports